import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Loading from "../../components/Loading";
import { AuthContext } from "../../../../contexts/AuthContext";
import DynamicForm from "../forms/DynamicForm";
import { listFileService } from "../../../../services/api/listFileService";

const safe = (v, d = "") => (v == null ? d : v);

const normalizeResponse = (response) => {
  const profile = response?.profile ?? {};
  const serviceId = profile?.serviceId ?? {};
  const category = serviceId?.category ?? {};
  const hasLogoArray = Array.isArray(profile?.logo) && profile.logo.length > 0;
  return {
    brand: safe(profile.brand),
    formName: safe(serviceId.formName),
    customer_name: safe(response?.createdByInfo?.account?.fullName),
    customer_phone: safe(response?.createdByInfo?.phone),
    customer_avatar: safe(response?.createdByInfo?.avatar?.url),
    customer_email: safe(response?.createdByInfo?.account?.email),
    profile_name: safe(serviceId.serviceName),
    profile_image: hasLogoArray
      ? profile.logo
      : profile?.image?.url || "/images/default-profile.png",
    soDon: safe(profile.profileCode),
    soBang: safe(profile.numberOfCertificates),
    category: safe(category.categoryName),
    createDate: safe(profile.createdDate),
    issueDate: safe(profile.issueDate),
    dateActive: safe(profile.dateActive),
    expiryDate: safe(profile.expiryDate),
    status: (() => {
      const s = profile.status || "Đã hoàn thành";
      return { value: s, label: s };
    })(),
    statusColor:
      profile.status === "Chờ duyệt"
        ? "bg-orange-500"
        : profile.status === "Đang triển khai"
          ? "bg-blue-500"
          : profile.status === "Tạm ngưng"
            ? "bg-red-500"
            : "bg-green-500",
    isLookup: profile.isLookup ?? true,
    isRequire: profile.isRequire || false,
    isOriginal: profile.isOriginal || false,
    contentRequire: profile.contentRequire || "",
  };
};

const DocumentDetail = ({ isMobile }) => {
  const { token_client } = useContext(AuthContext);
  const { id } = useParams();

  const [loading, setLoading] = useState(true);
  const [hasLoadedOnce, setHasLoadedOnce] = useState(false);
  const [documentData, setDocumentData] = useState(null);
  const [process, setProcess] = useState([]);
  const [data, setData] = useState(null);
  const [represent, setRepresent] = useState(null);
  const [category, setCategory] = useState("");

  const abortRef = useRef(null);

  const fetchService = useCallback(async () => {
    try {
      setLoading(true);
      if (abortRef.current) abortRef.current.abort?.();
      abortRef.current = new AbortController();

      const res = await listFileService.get_by_id(id, token_client);
      setCategory(res?.data?.profile?.serviceId?.category?.categoryName || "");
      setDocumentData(res?.data?.profile?.info || []);
      setProcess(res?.data?.profile?.processes || []);
      setRepresent(res?.data?.profile?.represent ?? null);
      setData(normalizeResponse(res?.data || {}));
    } catch (error) {
      toast.dismiss();
      toast.error("Lỗi khi lấy dịch vụ từ server");
      setDocumentData([]);
      setProcess([]);
      setRepresent(null);
      setData(null);
    } finally {
      setLoading(false);
      setHasLoadedOnce(true);
    }
  }, [id, token_client]);

  useEffect(() => {
    fetchService();
  }, [fetchService]);

  if (loading && !hasLoadedOnce) {
    return (
      <div
        className={`flex ${isMobile ? "h-screen w-screen" : "h-full"
          } items-center justify-center`}
      >
        <Loading />
      </div>
    );
  }

  return (
    <DynamicForm
      documentData={documentData}
      process={process}
      data={data}
      represent={represent}
      category={category}
      isMobile={isMobile}
    />
  );
};

export default DocumentDetail;
